define(["exports", "./utils"], function (_exports, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  // @ts-check
  // Module core/data-abbr
  // - Finds all elements with data-abbr attribute and processes them.
  const name = "core/dfn-abbr";
  _exports.name = name;

  function run() {
    /** @type {NodeListOf<HTMLElement>} */
    const elements = document.querySelectorAll("[data-abbr]");

    for (const elem of elements) {
      const {
        localName
      } = elem;

      switch (localName) {
        case "dfn":
          processDfnElement(elem);
          break;

        default:
          {
            const msg = "[`data-abbr`](https://github.com/w3c/respec/wiki/data-abbr)" + " attribute not supported on `".concat(localName, "` elements.");
            (0, _utils.showInlineWarning)(elem, msg, "Error: unsupported.");
          }
      }
    }
  }
  /**
   * @param {HTMLElement} dfn
   */


  function processDfnElement(dfn) {
    const abbr = generateAbbreviation(dfn); // get normalized <dfn> textContent to remove spaces, tabs, new lines.

    const fullForm = dfn.textContent.replace(/\s\s+/g, " ").trim();
    dfn.insertAdjacentHTML("afterend", " (<abbr title=\"".concat(fullForm, "\">").concat(abbr, "</abbr>)"));
    const lt = dfn.dataset.lt || "";
    dfn.dataset.lt = lt.split("|").filter(i => i.trim()).concat(abbr).join("|");
  }

  function generateAbbreviation(elem) {
    if (elem.dataset.abbr) return elem.dataset.abbr; // Generates abbreviation from textContent
    // e.g., "Permanent Account Number" -> "PAN"

    return elem.textContent.match(/\b([a-z])/gi).join("").toUpperCase();
  }
});
//# sourceMappingURL=data-abbr.js.map